import { Helper } from '../Helper';
export class ExportSingleHelper extends Helper {
    constructor(options) {
        super();
        this.options = options;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getCurrentModule);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.export(this.options));
    }
}

//# sourceMappingURL=ExportSingleHelper.js.map
